module.exports = require("@swa-ui/itinerary/src/AutocompleteLocations/AutocompleteLocations.module.scss");